import Page from "pages/page";
import IntegrationsTab from "./integrations-tab";
import "./integrations.scss";

const IntegrationsPage = () => {
  return (
    <Page name="integrations" title="Integrations" icon="exchange">
      <IntegrationsTab />
    </Page>
  );
};

export default IntegrationsPage;
